export function logger(...args) {
  if (
    process.env.NEXT_PUBLIC_NODE_ENV === "staging" ||
    process.env.NEXT_PUBLIC_NODE_ENV === "local"
  ) {
    console.log(...args);
  }
}

export function localLogger(...args) {
  if (process.env.NEXT_PUBLIC_NODE_ENV === "local") {
    console.log(...args);
  }
}
